// src/App.tsx

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// --- Global Layout Components ---
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import ScrollToTop from './components/Utils/ScrollToTop';
import AnalyticsTracker from './components/Utils/AnalyticsTracker';

// --- Page Components ---
import HomePage from './pages/HomePage';
import AboutUsPage from './pages/AboutUsPage';
import PortfolioPage from './pages/PortfolioPage';
import InvestorRelationsPage from './pages/InvestorRelationsPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CompliancePage from './pages/CompliancePage';
import Profile1 from './pages/Profile/Profile1';
import Profile2 from './pages/Profile/Profile2';
import Profile3 from './pages/Profile/Profile3';
import ProfileKankam from './pages/Profile/ProfileKankam';
import ProfileNii from './pages/Profile/ProfileNii';

// Import global styles
import './css/Global.module.css';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <AnalyticsTracker /> 
      
      <Header />
      <main>
        <Routes>
          {/* Main Corporate Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/investors" element={<InvestorRelationsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Legal & Governance */}
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/compliance" element={<CompliancePage />} />

          {/* Dynamic Profile Routes */}
          <Route path="/profile/Atoapoma" element={<Profile1 />} />
          <Route path="/profile/Amewu" element={<Profile2 />} />
          <Route path="/profile/Silas" element={<Profile3 />} />
          <Route path="/profile/kankam" element={<ProfileKankam />} />
          <Route path="/profile/Nii" element={<ProfileNii />} />

          {/* Catch-all for 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default App;